module.exports = __webpack_public_path__ + "img/a9f7e353-8f29-4c10-8ae4-5a9da096fa66.e9e372ba.jpg";